import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { MapboxComponent } from '../core/components/map/map.component';

import { OrderDetailComponent } from '../core/modals/order-preview/components/order-detail/order-detail.component';
import { OrderPreviewComponent } from '../core/modals/order-preview/order-preview.component';
import { PaymentComponent } from '../core/modals/order-preview/components/payment/payment.component';
import { DataStateModule } from './data-state/data-state.module';
import { PassOrderConfirmationComponent } from '../core/modals/pass-order/pass-order-confirmation.component';
import { OrderPhotosComponent } from '../core/modals/order-preview/components/photos/order-photos.component';
import { ExtraInfoComponent } from '../core/modals/order-preview/components/extra-info/extra-info.component';
import { MailComponent } from '../core/modals/order-preview/components/mail/mail.component';
import { QrCodeComponent } from '../core/modals/order-preview/components/payment/components/qr-code/qr-code.component';
import { CashComponent } from '../core/modals/order-preview/components/payment/components/cash/cash.component';
import { NextOrderComponent } from '../core/modals/next-order/next-order.component';
import { BancontactTerminalReminderComponent } from '../core/modals/bancontact-terminal-reminder/bancontact-terminal-reminder/bancontact-terminal-reminder.component';
import { EndDeliveryComponent } from '../core/modals/end-delivery/end-delivery.component';
import { ConfirmDeliveryComponent } from '../core/modals/end-delivery/confirm-delivery/confirm-delivery.component';
import { PaymentReminderComponent } from '../core/modals/end-delivery/payment-reminder/payment-reminder.component';
import { OrderDeliveredPhotoComponent } from '../core/modals/end-delivery/order-delivered-photo/order-delivered-photo.component';
import { PassedOrderPreviewComponent } from '../core/modals/passed-order-preview/passed-order-preview.component';
import { ExtraInfoReminderComponent } from '../core/modals/extra-info-reminder/extra-info-reminder.component';
import { ExpandableTextComponent } from './expandable-text/expandable-text.component';
import { LottieModule } from 'ngx-lottie';
import { CardComponent } from '../core/modals/order-preview/components/payment/components/card/card.component';
import { SmsMessageModalComponent } from '../core/modals/send-sms/send-sms.component';

const COMPONENTS = [
    PaymentComponent,
    PassOrderConfirmationComponent,
    OrderDetailComponent,
    OrderPreviewComponent,
    MapboxComponent,
    ExtraInfoComponent,
    OrderPhotosComponent,
    MailComponent,
    QrCodeComponent,
    CashComponent,
    CardComponent,
    NextOrderComponent,
    BancontactTerminalReminderComponent,
    EndDeliveryComponent,
    ConfirmDeliveryComponent,
    PaymentReminderComponent,
    OrderDeliveredPhotoComponent,
    PassedOrderPreviewComponent,
    ExtraInfoReminderComponent,
    ExpandableTextComponent,
    SmsMessageModalComponent

];

@NgModule({
    declarations: COMPONENTS,
    imports: [
        CommonModule,
        IonicModule,
        FormsModule,
        ReactiveFormsModule,
        DataStateModule,
        LottieModule
    ],
    exports: [
        ...COMPONENTS,
        DataStateModule
    ],
})
export class SharedModule { }
